module.exports = __webpack_public_path__ + "img/brasao.c8102142.svg";